var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDsrun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDsrun0)",
    d: "M9.956 6.621a4.77 4.77 0 0 1 2.228-2.335c0 1.345-.098 1.697-.15 1.705c.197.018.647.073.9.168c.27-.266 1.56-.588 1.852-.588a2.28 2.28 0 0 1-.887 1.248c.171.11.531.44.612.608c.12-.188.84-.141 1.059-.141c.227-.592 1.123-.866 1.333-.866c.321-.536 1.251-.814 1.526-.849c-.086.292-.485.72-.703.72a.8.8 0 0 0-.429.129h.373c-.09.236-.519.617-.93.617c-.33 0-.609.197-.703.249h.772c-.163.471-.463.514-1.166.514c-.562 0-.943.27-1.072.343h1.312c-.133.595-.986.557-1.402.523c.112.043.386.128.596.128c.214 0 .416-.085.493-.128c.039.36.857 1.08 1.406 1.525c.548.446 1.028.579 1.144.943c.086.283.026.892-.283 1.526c-.116.236-.321.291-.857.643c-.544.36-.604.484-.771.484a.93.93 0 0 1-.575-.236c-.437-.463-1.324-.497-1.517-.497c-.188 0-.493.043-.694.155c0 .454.566 1.958 1.47 2.442a4.08 4.08 0 0 1 2.228 3.206c-.968-2.387-3.934-2.67-4.791-2.953s-1.564-1.688-1.83-2.19c1.487 1.299 1.826 1.53 2.786 1.929c-1.972-1.235-2.555-3.652-2.572-4.715c.497 1.295.947 1.535 2.563 1.535c1.727 0 2.529.887 2.842.887c.308 0 .342-.189.711-.386c.291-.163.514-.3.596-.347v-.219c.115-.17.355-.557.355-.754c0-.244-.18-.488-.638-.488c-.364 0-.759.317-.857.415l.235-.561a22 22 0 0 0-.771-.771c-.964-1.003-1.629-1.393-2.057-1.573c-.433-.185-.45-.33-.45-.6c0-.275-.934-.892-.934-1.029s.128-.189.347-.317c-1.243 0-2.087.424-2.357.634c.115.009.33.095.415.146a4.6 4.6 0 0 0-1.885.99c-.052.086-.408 1.037-.408 1.817c0 .626-.094 1.371-.064 1.693c-.038-.056-.086-.167-.214-.429c0 2.76 1.286 3.292 1.286 4.929A1.67 1.67 0 0 1 8.57 18v-.429c-.904 1.127-1.495 1.286-2.142 1.286c.565-.214 1.015-.827 1.015-1.38c0-.446-.415-1.101-.587-1.406v.643c-.986-.96-.656-2.768-.428-3.643c-.065.107-.275.373-.429.643c.266-4.941 3.094-6.741 3.956-7.093"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#tokenBrandedDsrun1)",
    d: "M12 8.601c.047-.008 1.226-.257 1.286.827c-.326 0-.96-.23-1.286-.827"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDsrun0",
    x1: 16.542,
    x2: 5.66,
    y1: 5.847,
    y2: 14.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1912B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F25F2B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "tokenBrandedDsrun1",
    x1: 16.542,
    x2: 5.66,
    y1: 5.847,
    y2: 14.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1912B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F25F2B"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDsrun);
export default __webpack_public_path__ + "static/media/dsrun.acf30e5df54738a6f7a16cdfc40336d3.svg";
export { ForwardRef as ReactComponent };